import { render } from "./BlogPostsList.vue?vue&type=template&id=8329b58a"
import script from "./BlogPostsList.vue?vue&type=script&lang=js"
export * from "./BlogPostsList.vue?vue&type=script&lang=js"
script.render = render

export default script